import React from "react";
import Select from "../Select";
import SearchSelect from "../SerachSelect";

const TRANSPORT_TYPE_OPTIONS = [
  { label: "Onwards", value: "onward" },
  { label: "Return", value: "return" },
  { label: "Transfers", value: "transfers" },
];

const TransportEntry = ({ plan, onUpdate, onwardOptions = [], returnOptions = [], transferOptions = [] }) => {
  console.log("🚀 ~ TransportEntry ~ plan:", plan.transportType, returnOptions);
  const vehicleOptions =
    plan.transportType === "return" ? returnOptions :
    plan.transportType === "transfers" ? transferOptions :
    onwardOptions;

  return (
    <div className="">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="text-sm font-medium text-gray-600 mb-1 block">Transport Type</label>
          <Select
            options={TRANSPORT_TYPE_OPTIONS}
            value={TRANSPORT_TYPE_OPTIONS.find((o) => o.value === plan.transportType) || null}
            onChange={(e) => {
              onUpdate("transportType", e.value);
              onUpdate("transportOption", null);
            }}
            placeholder="Select Type..."
          />
        </div>
        <div>
          <label className="text-sm font-medium text-gray-600 mb-1 block">Vehicle</label>
          <SearchSelect
            options={vehicleOptions}
            value={plan.transportOption || null}
            onChange={(option) => onUpdate("transportOption", option)}
            placeholder="Select Vehicle..."
          />
        </div>
      </div>
    </div>
  );
};

export default TransportEntry;
